import DefaultExpensesManagement from "./ExpensesManagement";

export default DefaultExpensesManagement;
